module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACE3AAAhNwEzWJ96AAAAxUlEQVR4nO3awQ3CMAwFUMMEjMIIbNpuwiiMUi6VOMSNoI2aUr0n+eJbbCm+/AAAAAAAgL5uETFExKQ21TDP8meG366GpeFfis7HVHTYIp31teiwq9oCxqLDWqtm6Qi3qdVHGAAAAAAAAAAAOB/BrM7BLMNvu4RUmtidTUWHLdJZ18K57KC2AOnodqSjO///0tEAAAAAAAAAAMDh3SPimYSgBLN28koeevQlnMYjeeA/VKoWzoVFvqDOHGEAAAAAAPhSRLwB2n7JXtl135MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/ic_menu@3x.png
// module id = 711
// module chunks = 0